import { type PropsWithChildren, type ReactNode } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

import type { SelectTriggerWidthOptionsType } from './types.js';

/**
 * @public
 */
export type SelectV2TriggerProps = PropsWithChildren &
  StylingProps &
  DataTestId & {
    /**
     * The placeholder text displayed in the SelectV2.Trigger.
     */
    placeholder?: ReactNode;
    /**
     * The width of the SelectV2.Trigger.
     * @defaultValue 'content'
     */
    width?: SelectTriggerWidthOptionsType;
  };

/**
 * @public
 */
export function SelectV2Trigger(props: SelectV2TriggerProps): null {
  return null;
}
